import { Section } from '../components/Section/Section'
import { Metric } from '../components/Metric/Metric'
import { useAnalyticsContext } from '../AnalyticsContext'

export const GrowthAndDiscovery = () => {
  const { period } = useAnalyticsContext()

  return (
    <Section title="Growth & Discovery">
      <Metric
        name="Impressions"
        metricName="page_impressions"
        period={period}
        tooltip="Total times all your page posts have been seen"
      />
      <Metric
        name="Reach"
        metricName="page_impressions_unique"
        period={period}
        tooltip="Unique accounts that viewed your posts"
      />
      <Metric
        name="Engagement"
        metricName="page_post_engagements"
        period={period}
        tooltip="Total number of times people have engaged with your posts"
      />
    </Section>
  )
}
